//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'dev',
  title: 'Sierra Finance',
  name: 'sierra-finance',
  asset: {
    stationAssetTypeReference: '67abfb9aee06eac3505f9834',
  },
  /**
   * Deploy-time feature switches (#5166). Off here means the control is not rendered at all; the API gates
   * the same capability independently, so flipping this on without the matching server flag surfaces a
   * control whose calls are refused.
   */
  features: {
    /** Lets a clerk mark an AP document as requiring a Constancia regardless of its line classifications. */
    forcedWithholding: false,
  },

  proxyUrls: {
    assetApi: 'https://asset.api.dev.sierra-erp.com',
    itemApi: 'https://item.api.dev.sierra-erp.com',
    userMasterApi: 'https://user.api.dev.sierra-erp.com',
    inventoryApi: 'https://inventory.api.dev.sierra-erp.com',
    orderApi: 'https://order.api.dev.sierra-erp.com',
    productionApi: 'https://production.api.dev.sierra-erp.com',
    financeApi: 'https://finance.api.dev.sierra-erp.com',
  },
  domainUrl: {
    order: 'https://www.order-dev.sierra-erp.com',
  },
  externalSitesUrls: {
    itemModule: 'sierra.textiles.come',
  },
};
